import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { EquipoPedagogicoModel } from '../../../../../model/Identificacion.model'
import { EstamentoModel } from '../../../../../model/Identificacion.model'
import { apiService } from '../../../../../service/api.service';

import { FormControl, FormGroup, Validators, ValidatorFn, FormGroupDirective, NgForm, FormBuilder } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
  selector: 'app-modal-miembros-equipo-pedagogico',
  templateUrl: './modal-miembros-equipo-pedagogico.component.html',
  styleUrls: ['./modal-miembros-equipo-pedagogico.component.css']
})
export class ModalEditarMiembroComponent implements OnInit {

  dataMiembro = new EquipoPedagogicoModel();
  tipoModal= '';
  opcionesEstamentos : EstamentoModel[] = [];
  busqueda = new EquipoPedagogicoModel();
  disabledCrear = true
  disabledEditar = false;
  busquedaRut = false
  public formCrear: FormGroup;
  public formEditar: FormGroup;
  stateRutValido = new StateRut(); 
  constructor(
    public dialogRef: MatDialogRef<ModalEditarMiembroComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public api:apiService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.dataMiembro = new EquipoPedagogicoModel();
    this.tipoModal = this.data.tipoModal;

    //this.dataMiembro = Object.assign(this.data.dataMiembro);
    this.dataMiembro.idPersona = this.data.dataMiembro.idPersonaPeriodo;
    this.dataMiembro.rut = this.data.dataMiembro.rut;
    this.dataMiembro.nombres = this.data.dataMiembro.nombres;
    this.dataMiembro.apellido = this.data.dataMiembro.apellido;
    this.dataMiembro.correoParticular= this.data.dataMiembro.correoParticular;
    this.dataMiembro.telefono = this.data.dataMiembro.telefono;  
    this.dataMiembro.estamento.idTablaMaestra = this.data.dataMiembro.estamento.idTablaMaestra;

    this.opcionesEstamentos =  this.data.estamentos.payload;


    this.formularios();
  }
 
  formularios(){
    this.formCrear = this.formBuilder.group({
        rut: new FormControl('',[Validators.required]),
        nombres: new FormControl({ value: '', disabled: true }, [Validators.required]),
        apellido: new FormControl({ value: '', disabled: true }, [Validators.required]),
        correoParticular: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
        telefono: new FormControl({ value: '', disabled: true }, [Validators.required]),
        idTablaMaestra: new FormControl({ value: '', disabled: true }, [Validators.required]),
      
      },{validator:[,this.validarRut]}
    );

    

    this.formEditar = new FormGroup({
      rut: new FormControl({ value: '', disabled: true }, [Validators.required]),
      nombres: new FormControl('', [Validators.required]),
      apellido: new FormControl('', [Validators.required]),
      correoParticular: new FormControl('', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
      telefono: new FormControl('', [Validators.required]),
      idTablaMaestra: new FormControl('', [Validators.required]),
    
    });
  }

  validarRut(formulario:FormGroup){
   
    let rut = formulario.get('rut').value != null ? formulario.get('rut').value  : ''
    let cRut = rut.replace(/[\.-]/g, '');
    cRut = cRut.toUpperCase();
    var patt = /^\d{1,8}[0-9K]$/;
    var ok = patt.test(cRut);
    var cStr = cRut.slice(0, -1);
    var cDig = cRut.slice(-1);
    var nSum = 0;
    var nVal = 0;
    var cVal = "";

    if (ok) {
        for (let nMul = 2; cStr != ""; nMul = (nMul == 7) ? 2 : nMul + 1) {
            nSum += Number(cStr.slice(-1)) * nMul;
            cStr = cStr.slice(0, -1);
        }
        nVal = 11 - (nSum % 11);
        switch (nVal) {
            case 11:
                cVal = "0";
                break;
            case 10:
                cVal = "K";
                break;
            default:
                cVal = nVal.toString();
        }
        
        ok = cVal == cDig;
    }
    if(!ok && cRut.length >= 8 ){  
      return {rutValido:true};
    }else if(ok && (cRut.length >= 8 && cRut.length <=10)){ 
      return null;  
    } 
 
  }

  buscar(){ 
    if(this.formCrear.controls['rut'].value == null){
      this.dataMiembro.rut = '';
    }else if(this.formCrear.controls['rut'].value != '' ){
      const rut =this.formCrear.controls['rut'].value.replace('-','')
      this.api.API_POST_buscarMiembro(rut).subscribe((response) => {
        this.busqueda = response.payload;
        this.llenarFormCrear(response.payload);
        this.disabledCrear = false;
        this.busquedaRut = true;
        this.enableForm();
      },
      (err) => {
        console.log(err)
      })
    }
  }

  llenarFormCrear(data){
    this.formCrear.controls['rut'].setValue(data.rut)
    this.formCrear.controls['nombres'].setValue(data.nombres)
    this.formCrear.controls['apellido'].setValue(data.apellido)
    this.formCrear.controls['correoParticular'].setValue(data.correoParticular)
    this.formCrear.controls['telefono'].setValue(data.telefono)
    this.formCrear.controls['idTablaMaestra'].setValue(data.estamento.idTablaMaestra == 0 ? null : data.estamento.idTablaMaestra)
  }

  enableForm(){
    this.formCrear.controls['nombres'].enable();
    this.formCrear.controls['apellido'].enable();
    this.formCrear.controls['correoParticular'].enable();
    this.formCrear.controls['telefono'].enable();
    this.formCrear.controls['idTablaMaestra'].enable();
  }

  guardarNuevoMiembro(){
    if (this.formCrear.valid) {
      
      const nuevo = {
        "idJardin": this.api.dataJardin.id,
        "miembro": this.guardarModelo()
      }

      this.api.API_POST_nuevoMiembro(nuevo).subscribe((response) => {
        this.dialogRef.close('refresh');
      },
      (err) => {
        console.log(err)
      })
    }
  }

  guardarModelo(){    
    this.dataMiembro.rut = this.formCrear.controls['rut'].value;
    this.dataMiembro.nombres = this.formCrear.controls['nombres'].value;
    this.dataMiembro.apellido = this.formCrear.controls['apellido'].value;
    this.dataMiembro.correoParticular = this.formCrear.controls['correoParticular'].value;
    this.dataMiembro.telefono = this.formCrear.controls['telefono'].value;
    this.dataMiembro.estamento.idTablaMaestra = this.formCrear.controls['idTablaMaestra'].value;
    return this.dataMiembro;
  }

  editarMiembro(){

    if (this.formEditar.valid) {
      this.disabledEditar = true;
      this.api.API_POST_editarMiembro(this.dataMiembro).subscribe((response) => {
        this.disabledEditar = false;
        this.dialogRef.close('refresh');
      },
      (err) => {
        console.log(err)
      }) 
    }
  }
  eliminarMiembro(){

    this.api.API_POST_eliminarMiembro(this.dataMiembro.idPersona).subscribe((response) => {
      this.dialogRef.close('refresh');
    },
    (err) => {
      console.log(err)
    })
  }


  public hasError = (controlName: string, errorName: string) =>{
    return this.formCrear.controls[controlName].hasError(errorName);
  }
  public hasErrorEditar = (controlName: string, errorName: string) =>{
    return this.formEditar.controls[controlName].hasError(errorName);
  }
    

}
export class StateRut implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form:  FormGroupDirective | NgForm | null): boolean {
    const dirty = control.dirty;
    if ( dirty !== null ) {
      return dirty && control.invalid;
    }
  }
}